import { useEffect, useState } from 'react';

export const useAnimatedEllipses = (loading: boolean) => {
	const [animatedLabel, setAnimatedLabel] = useState('');

	useEffect(() => {
		if (!loading) return;

		const animationStates = ['', '.', '..', '...'];
		let currentIndex = 1;

		const intervalId = setInterval(() => {
			setAnimatedLabel(animationStates[currentIndex]);
			currentIndex = (currentIndex + 1) % animationStates.length;
		}, 500);

		return () => clearInterval(intervalId);
	}, [loading]);

	return animatedLabel;
};
